import car1 from '../assets/car1.jpeg'
import car2 from '../assets/car2.jpeg'
import car3 from '../assets/car3.jpeg'
import car4 from '../assets/car4.jpeg'
import car5 from '../assets/car5.jpeg'
import car6 from '../assets/car6.jpeg'
import car7 from '../assets/car7.jpeg'
import car8 from '../assets/car8.jpeg'
import car9 from '../assets/car9.jpeg'
import car10 from '../assets/car10.jpeg'



export const db = [
  {
    id: 1,
    image: car1,
    tag: 'sport, racing, lambo'
  },
  {
    id: 2,
    image: car2,
    tag: 'luxury, aston martin, red'
  },
  {
    id: 3,
    image: car3,
    tag: 'sport, convertible, white'
  },
  {
    id: 4,
    image: car4,
    tag: 'luxury, racing, red'
  },
  {
    id: 5,
    image: car5,
    tag: 'tyre, racing, black'
  },
  {
    id: 6,
    image: car6,
    tag: 'chevrolet, sport, white'
  },
  {
    id: 7,
    image: car7,
    tag: 'audi, racing, tyre'
  },
  {
    id: 8,
    image: car8,
    tag: 'sport, racing, blue'
  },
  {
    id: 9,
    image: car9,
    tag: 'tyre, racing, black'
  },
  {
    id: 10,
    image: car10,
    tag: 'sport, lambo, yellow'
  },
]